var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91675 3.4165H2.50008C2.27907 3.4165 2.06711 3.5043 1.91083 3.66058C1.75455 3.81686 1.66675 4.02882 1.66675 4.24984V7.99984C1.66675 8.22085 1.75455 8.43281 1.91083 8.58909C2.06711 8.74537 2.27907 8.83317 2.50008 8.83317H6.25008C6.4711 8.83317 6.68306 8.74537 6.83934 8.58909C6.99562 8.43281 7.08341 8.22085 7.08341 7.99984V7.58317",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 2.58338L7.91667 3.83338M8.49375 3.24379C8.65785 3.07969 8.75004 2.85712 8.75004 2.62504C8.75004 2.39297 8.65785 2.1704 8.49375 2.00629C8.32965 1.84219 8.10708 1.75 7.875 1.75C7.64292 1.75 7.42035 1.84219 7.25625 2.00629L3.75 5.50004V6.75004H5L8.49375 3.24379Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerEdit);
export default __webpack_public_path__ + "static/media/tabler_edit.8225e5f6e2183c7b3d0a9385c10c942a.svg";
export { ForwardRef as ReactComponent };